import React, { useEffect } from 'react';
import Header from '../Layout/header';
import { TrackingParams } from '../Layout/types';
import useCountdown from '@/hooks/useCountDown';
import cn from 'classnames';
import LoyaltyIconWithModal from '@/components/rewards/RewardsIconWithModal';
import useTranslation from 'next-translate/useTranslation';
import EventEmitter, { actions } from '@/utils/eventemitter';
import { CmsComponentProps } from '@/types/cms';
import { twMerge } from 'tailwind-merge';
import { useComponentTheme } from '../../hooks/useComponentTheme';

type LightningTitleProps = {
  hideTimeString?: boolean;
  trackingParams?: TrackingParams;
} & CmsComponentProps;
function LightningTitle(props: LightningTitleProps) {
  const { data } = props;
  const { products } = data;

  const currentProduct = products[0] || ({} as any);
  if (currentProduct.id) {
    return <LightningTitleContent data={data} currentProduct={currentProduct} {...props} />;
  }
  return null;
}

const LightningTitleContent: React.FC<LightningTitleProps & { data: any; currentProduct: any }> = ({
  data,
  currentProduct,
  hideTimeString,
  trackingParams,
  ...props
}) => {
  const { properties, pageTheme = null } = props;
  const {
    current_timestamp,
    server_timestamp_now,
    server_timestamp_today_finish,
    server_timestamp_today_start,
    component_metadata
  } = data;

  const levelIcon = component_metadata?.icon_url;
  const { title, more_link } = component_metadata ?? {};
  const { t } = useTranslation();
  const _title = title || props.properties?.title || t('common.lightning_title');
  const { titleStyle } = useComponentTheme({ properties, pageTheme });

  let showOngoing = false,
    showBegoing = false,
    startTime,
    endTime;
  if (currentProduct.status === 'ongoing') {
    showOngoing = true;
    startTime = current_timestamp || server_timestamp_now;
    endTime = server_timestamp_today_finish;
  } else if (currentProduct.status === 'begoing') {
    showBegoing = true;
    startTime = current_timestamp || server_timestamp_now;
    endTime = server_timestamp_today_start;
  }

  const { timeString, remind } = useCountdown(() => endTime, {
    remindAfter: 300,
    start: () => startTime,
    onEnd: () => {
      location.reload();
    }
  });

  useEffect(() => {
    if (remind) {
      EventEmitter.emit(actions.lightningReload);
    }
  }, [remind]);

  if (hideTimeString) {
    return (
      <Header
        trackingParams={trackingParams}
        cmsComponentKey={props.cmsComponentKey}
        moreLink={more_link}
        title={
          <div className="flex flex-row justify-between items-center max-w-full">
            <LoyaltyIconWithModal
              showInfoIcon={!!levelIcon}
              showLevelIcon={!!levelIcon}
              levelIcon={levelIcon}
              messageType={'lightning'}
              text={_title}
              titleStyle={titleStyle}
            />
          </div>
        }
      />
    );
  }

  if (hideTimeString) {
    return (
      <Header
        trackingParams={trackingParams}
        cmsComponentKey={props.cmsComponentKey}
        moreLink={more_link}
        title={
          <div className="flex flex-row justify-between items-center max-w-full">
            <span className="overflow-hidden whitespace-nowrap text-ellipsis">
              <LoyaltyIconWithModal
                showInfoIcon={!!levelIcon}
                showLevelIcon={!!levelIcon}
                levelIcon={levelIcon}
                messageType={'lightning'}
                text={_title}
                titleStyle={titleStyle}
              />
            </span>
          </div>
        }
      />
    );
  }

  return (
    <Header
      moreLink={more_link}
      cmsComponentKey={props.cmsComponentKey}
      title={
        <div className="flex flex-row justify-between items-center max-w-full">
          <span className="overflow-hidden whitespace-nowrap text-ellipsis">
            <LoyaltyIconWithModal
              showInfoIcon={!!levelIcon}
              showLevelIcon={!!levelIcon}
              messageType={'lightning'}
              text={title}
            />
            <span
              className={twMerge(
                cn({
                  ['text-[#008ed6]']: showBegoing,
                  ['text-[#f26f6f]']: showOngoing
                })
              )}>
              {!!timeString && `（${t(showBegoing ? 'home:begins_in' : 'home:ends_in', { timeString: timeString })}）`}
            </span>
          </span>
        </div>
      }
    />
  );
};

export default React.memo(LightningTitle);
